import { mapActions } from 'vuex';

export default {
  name: 'originUserCkeckIn',
  methods: {
    ...mapActions(['global/setUserCheckinOrigin']),

    checkinOriginUser({ utm_medium = null, utm_source = null, t = null }) {
      const value = `${utm_medium}_${utm_source}_${t}`;
      const origin = this.checkResultUserOrigin(value);
      this['global/setUserCheckinOrigin'](origin);
    },
    checkResultUserOrigin(result) {
      const possibilities = {
        null_nav_null: 'nav',
        senhas_qrcode_null: 'tracking_qrcode',
        senhas_sms_null: 'tracking_sms',
        wifi_visitantes_null: 'wifi_visitante_unidade',
        qrcode_qrcode_null: 'qrcode_unidade',
        qrcode_site_null: 'qrcode_site_vacgripe',
        basic_page_null_null: 'site_referral',
        referral_null_null: 'site_referral',
        organic_null_null: 'organic_search',
        totem_null_null: 'qrcode_unidade',
        cubo_anfitriao_null_null: 'qrcode_unidade',
        pasta_null_null: 'qrcode_unidade',
        null_promoter_null: 'qrcode_promoter',
        token_mkt: 'qrcode_unidade',
        whatsapp_crm_48h: 'wpp_checkin_48h',
        whatsapp_crm_24h: 'wpp_checkin_24h',
        whatsapp_null_2h: 'wpp_conf_t2=0',
      };

      return possibilities[result] || 'other';
    },
  },
};
